import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_ACTIVITIES_FULFILLED: (state, action) => ({
			...state,
			activities: action.payload.activities,
		}),
	},
	{
		activities: [],
	},
);



// WEBPACK FOOTER //
// ./src/reducers/activity.js